import { ITranslationEntry } from '../lang';

export const BG: ITranslationEntry = {
  translations: {
    notifications: 'известия',
    markAllAsRead: 'маркирай всички като прочетени',
    poweredBy: 'задвижвани от',
    settings: 'настройки',
  },
  lang: 'bg',
};
